import React from 'react';
import { cn } from '@/lib/utils';
import { severityMeta } from '@/lib/severity';
import './primitives.css';

/**
 * Severity chip: tinted fill, severity color, square marker and the
 * printed label (never color alone). Accepts any casing / alias
 * ('critical', 'CRIT', 'Medium'...); unknown values render as Info.
 *
 *   <SeverityBadge severity={brief.severity} />
 *   <SeverityBadge severity="High" short />      // HIGH / CRIT / MED
 */
export default function SeverityBadge({ severity, short = false, size = 'md', className, ...rest }) {
  const meta = severityMeta(severity);
  return (
    <span
      className={cn('is-badge is-sev-badge', size === 'sm' && 'is-badge--sm', className)}
      style={{ '--sev-color': meta.color, '--sev-bg': meta.bg, '--sev-border': meta.border }}
      title={short ? `${meta.label} severity` : undefined}
      {...rest}
    >
      <span className="is-sev-mark" aria-hidden="true" />
      {short ? meta.short : meta.label}
      {short && <span className="sr-only"> severity</span>}
    </span>
  );
}
